module.exports = __webpack_public_path__ + "img/Red-L-2@2x.9da497a8.png";